export interface OutboundSchedulePolicyDay {
    dayOfWeek: number; // 0 = Sunday, 1 = Monday, etc.
    appointmentsInXDays: number;
    timeWindows: string[];
    retryUnconfirmedTimeWindows: string[];
}

export interface OutboundSchedulePolicy {
    dayOfWeekOverrides: OutboundSchedulePolicyDay[];
}

export const defaultOutboundSchedulePolicy: OutboundSchedulePolicy = {
    dayOfWeekOverrides: [
        { dayOfWeek: 0, appointmentsInXDays: 0, timeWindows: [], retryUnconfirmedTimeWindows: [] },
        { dayOfWeek: 1, appointmentsInXDays: 0, timeWindows: [], retryUnconfirmedTimeWindows: [] },
        { dayOfWeek: 2, appointmentsInXDays: 0, timeWindows: [], retryUnconfirmedTimeWindows: [] },
        { dayOfWeek: 3, appointmentsInXDays: 0, timeWindows: [], retryUnconfirmedTimeWindows: [] },
        { dayOfWeek: 4, appointmentsInXDays: 0, timeWindows: [], retryUnconfirmedTimeWindows: [] },
        { dayOfWeek: 5, appointmentsInXDays: 0, timeWindows: [], retryUnconfirmedTimeWindows: [] },
        { dayOfWeek: 6, appointmentsInXDays: 0, timeWindows: [], retryUnconfirmedTimeWindows: [] }
    ]
};

export const generateSchedulePolicyJson = (policy: OutboundSchedulePolicy): string => {
    return JSON.stringify(policy, null, 4);
};

export const parseSchedulePolicyJson = (value: string | OutboundSchedulePolicy | null | undefined): OutboundSchedulePolicy | null => {
    if (!value) {
        return null;
    }

    let parsed: any = value;
    for (let i = 0; i < 3 && typeof parsed === 'string'; i++) {
        if (!parsed.trim()) {
            return null;
        }

        try {
            parsed = JSON.parse(parsed);
        } catch (_) {
            return null;
        }
    }

    if (!parsed || !Array.isArray(parsed.dayOfWeekOverrides)) {
        return null;
    }

    const dayOfWeekOverrides = defaultOutboundSchedulePolicy.dayOfWeekOverrides.map(defaultDay => {
        const savedDay = parsed.dayOfWeekOverrides.find((day: any) => day?.dayOfWeek === defaultDay.dayOfWeek);
        return {
            dayOfWeek: defaultDay.dayOfWeek,
            appointmentsInXDays: typeof savedDay?.appointmentsInXDays === 'number' ? savedDay.appointmentsInXDays : defaultDay.appointmentsInXDays,
            timeWindows: Array.isArray(savedDay?.timeWindows) ? savedDay.timeWindows : defaultDay.timeWindows,
            retryUnconfirmedTimeWindows: Array.isArray(savedDay?.retryUnconfirmedTimeWindows) ? savedDay.retryUnconfirmedTimeWindows : defaultDay.retryUnconfirmedTimeWindows
        };
    });

    return { dayOfWeekOverrides };
};
